import { Component, Input } from "@angular/core";
import { Reference } from "../reference";

@Component({
  selector: "reference-inventory",
  styleUrls: ["./reference-inventory.component.css"],
  templateUrl: "./reference-inventory.component.html"
})
export class ReferenceInventoryComponent {
  @Input()
  public reference!: Reference;
}